$(function() {

    $('select[name=subcategory]').on('change', function(){
        $.oc.stripeLoadIndicator.show();
        var href = '/'+$('html').attr('lang')+'/shop/'+$('.js-category').data('slug');
        if($(this).val()){
            href += '/'+$(this).val();
        }
        window.location.href = href;
    });

    $('select[name=product_country]').on('change', function(){
        $.oc.stripeLoadIndicator.show();
        var slug = $(this).val();
        var subcategory = 'all';
        if($('select[name=subcategory]').val()){
            subcategory = $('select[name=subcategory]').val();
        }
        var href = '/'+$('html').attr('lang')+'/shop/'+$('.js-category').data('slug')+'/'+subcategory;
        if(slug){
            href += '/'+$(this).val();
        }
        window.location.href = href;
    });

    $('select[name=product_region]').on('change', function(){
        $.oc.stripeLoadIndicator.show();
        var slug = $(this).val();
        var subcategory_slug = $('select[name=subcategory]').val() ? $('select[name=subcategory]').val() : 'all';
        
        var href = '/'+$('html').attr('lang')+'/shop/'+$('.js-category').data('slug')+'/'+subcategory_slug+'/'+$('select[name=product_country]').val();
        if(slug){
            href += '/'+$(this).val();
        }
        window.location.href = href;
    });



    $('select[name=sort_by]').on('change', function(){
        $.oc.stripeLoadIndicator.show();
        $('#orderby_form').request('products::onChangeSortBy', {
            success: function(data) {
                window.location.reload();
            }
        })
    });

    $('.js-filter').on('change', function(){

        $.oc.stripeLoadIndicator.show();
        $('#filterby_form').request('products::onChangeFilterBy', {
            success: function(data) {
               window.location.href = window.location.href.split('?')[0];
            }
        });
    });

});
